<h2 mat-dialog-title>{{data?.title || 'Elija una opcion'}}</h2>
<mat-dialog-content> <span [innerHTML]="data?.body"></span></mat-dialog-content>
<div class="buttons">
  @for(choice of data.choices; track choice; let i = $index){
    @if (choice.text) {
      <button mat-button [mat-dialog-close]="i" class="{{choice.class || 'primary'}}">{{choice.text}}</button>
    } @else {
      <button mat-button [mat-dialog-close]="i" class="primary">{{choice}}</button>
    }
  }
</div>
